import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Colors } from "../Colors/Colors";

function InvalidFilterValuesDialog({ invalidValues, handleClose }) {
  return (
    <Dialog
      title={"Invalid Filter Values"}
      onClose={handleClose}
    >
      <div style={{ margin: "25px", textAlign: "center", fontSize: 16 }}>
        <p style={{ marginBottom: "15px", color: "var(--atlas-text-primary)" }}>
          The following filter values do not exist in the parent dataset:
        </p>
        <div
          style={{
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid var(--atlas-border-color)",
            padding: "10px",
            margin: "15px 0",
            backgroundColor: "var(--atlas-bg-secondary)",
            borderRadius: "4px",
            color: "var(--atlas-text-primary)",
          }}
        >
          {invalidValues.map((value, index) => (
            <div
              key={`${value}_${index}`}
              style={{
                padding: "5px 0",
                borderBottom:
                  index < invalidValues.length - 1 ? "1px solid var(--atlas-border-light)" : "none",
              }}
            >
              {value}
            </div>
          ))}
        </div>
        <p style={{ marginTop: "15px", color: Colors.error, fontWeight: "bold" }}>
          Import aborted. Please fix the filter values in your CSV file.
        </p>
      </div>
      <DialogActionsBar>
        <Button
          className="k-button"
          name={`btnInvalidFilterValuesClose`}
          style={{ backgroundColor: Colors.error }}
          onClick={handleClose}
        >
          Close
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
}

export default InvalidFilterValuesDialog;
